import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { MediaService } from './media.service';

@Injectable({
  providedIn: 'root',
})
export class MediaHandlerService {
  private renderer: Renderer2;

  constructor(
    private mediaService: MediaService,
    private rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  processMedia(
    rootElement: HTMLElement,
    type: 'poster' | 'video' | 'img'
  ): void {
    let selector: string;
    let attribute: string;

    // Determine selector and attribute based on type
    switch (type) {
      case 'poster':
        selector = '[poster-src]';
        attribute = 'poster-src';
        break;
      case 'video':
        selector = '[video-src]';
        attribute = 'video-src';
        break;
      case 'img':
        selector = '[data-src]';
        attribute = 'data-src';
        break;
    }

    const mediaElements = rootElement.querySelectorAll(selector);

    Array.from(mediaElements).forEach((media: any) => {
      if (!media.getAttribute('data-processed')) {
        const mediaSrc = media.getAttribute(attribute);
        if (mediaSrc) {
          media.setAttribute('data-processed', 'true');
          this.mediaService.getMedia(mediaSrc).subscribe(
            (response) => {
              if (type === 'poster') {
                this.renderer.setAttribute(
                  media,
                  'poster',
                  response.mediaPreSignedUrl
                );
              } else if (type === 'video') {
                this.renderer.setAttribute(
                  media,
                  'src',
                  response.mediaPreSignedUrl
                );
              } else if (type === 'img') {
                this.renderer.setAttribute(
                  media,
                  'src',
                  response.mediaPreSignedUrl
                );
              }
            },
            (error) => {
              console.error(`Error fetching ${type} for ${mediaSrc}:`, error);
            }
          );
        }
      }
    });
  }

  observeMedia(
    rootElement: HTMLElement,
    callback: (type: 'poster' | 'video' | 'img') => void
  ): MutationObserver {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          if (mutation.target instanceof HTMLElement) {
            if (mutation.target.hasAttribute('poster-src')) {
              callback('poster');
            } else if (mutation.target.hasAttribute('video-src')) {
              callback('video');
            } else if (mutation.target.hasAttribute('data-src')) {
              callback('img');
            }
          }
        }
      });
    });

    observer.observe(rootElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ['poster-src', 'video-src', 'data-src'],
    });

    return observer;
  }
}
